import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["image"]

  open(event) {
    event.preventDefault()
    const src = this.imageTarget.src

    const overlay = document.createElement("div")
    overlay.className = "fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm cursor-zoom-out"
    overlay.style.animation = "fade-in 0.2s ease-out"
    overlay.innerHTML = `
      <img src="${src}" class="max-h-[90vh] max-w-[90vw] object-contain rounded-lg shadow-2xl" style="animation: scale-in 0.2s ease-out" />
    `

    const close = () => overlay.remove()
    overlay.addEventListener("click", close)
    document.addEventListener("keydown", function handler(e) {
      if (e.key === "Escape") {
        document.removeEventListener("keydown", handler)
        close()
      }
    })

    document.body.appendChild(overlay)
  }
}
